import metadata from './metadata'

let pageview = true
let ccr = null
let brevents = []
let eventname = ''
let purchaseID = null
let lastpurchaseID = null
let clickedRow

export const getMetaData = metadata.getMetaData
export const setMetaData = metadata.setMetaData
export const removeMetaData = metadata.removeMetaData

export const generatePurchaseID = function generatePurchaseID() {
  return purchaseID === null ? generateNewPurchaseID() : purchaseID
}

export const generateNewPurchaseID = function generateNewPurchaseID() {
  purchaseID = Math.round(Math.random() * 10000000).toString() + new Date().getTime()
  window.purchaseId = purchaseID
  setMetaData('PurchaseID', purchaseID)
  lastpurchaseID = purchaseID
  return purchaseID
}

export const getPurchaseID = function getPurchaseID() {
  return purchaseID
}

export const setPageView = function setPageView(val) {
  pageview = val
  return val
}

export const getPageView = function getPageView() {
  return pageview
}

export const setCCR = function setCCR(val) {
  ccr = val
  return val
}

export const getCCR = function getCCR() {
  return ccr
}

export const getClickedRow = function getClickedRow() {
  return clickedRow
}

export const setClickedRow = function setClickedRow(val) {
  clickedRow = val
  return val
}

export const getPID = function getPID() {
  let str = null
  let pid = getCookies('brmp')

  if (pid) {
    pid = decodeURIComponent(pid)
    let pidObj = JSON.parse(pid)

    if (pidObj.pid) {
      str = JSON.stringify(pidObj.pid)
    }
  }

  return str
}

export const setEvents = function setEvents(val) {
  brevents.push(val)
  return val
}

export const getCookies = function getCookies(name) {
  let value, parts
  if (name) {
    value = "; " + document.cookie
    parts = value.split("; " + name + "=")
    if (parts.length === 2) {
      return parts.pop().split(";").shift()
    }
  } else {
    value = "; " + document.cookie
    parts = value.split("; ")
    parts.shift()
    return parts.map(function (e) {
      let innerElm = e.split('=')
      return {
        name: innerElm[0],
        value: innerElm[1]
      }
    })
  }
}


export const cleanHouse = function cleanHouse() {
  setPageView(false)
  setCCR(null)
  setPageView(false)
  setClickedRow(null)
  purchaseID = null
  eventname = ''
  removeMetaData('PageMetadata:EventName')
  removeMetaData('PageMetadata:VideoName')
  removeMetaData('PageMetadata:VideoPlayer')
  removeMetaData('PageMetadata:VideoID')
  removeMetaData('PageMetadata:VideoLength')
  removeMetaData('PageMetadata:VideoPublishedDate')
}

export const countPaidListings = function countPaidListings(selector) {
  let str = ''
  let rows
  let source = document
  if (selector && typeof selector === "string") {
    source = document.querySelector(selector)
  }

  // Detect if there is a rate table
  let noresults = [].slice.call(source.querySelectorAll(".br-no-results")).filter(isVisible)

  if (source.querySelector("[data-ri-table-group]") || noresults.length > 0) {

    rows = [].slice.call(source.querySelectorAll("[data-paid='true']")).filter(function (e) {
      return (/omitcount/).test(e.className) ? '' : e
    })
    str = rows.length.toString()
  }

  if (str.length > 0) {
    setMetaData('PageListingCount', str)
  }

  return str
}

export const countEditorialListings = function countEditorialListings(selector) {
  let str = ''
  let rows
  let source = document
  if (selector && typeof selector === "string") {
    source = document.querySelector(selector)
  }

  // Detect if there is a rate table
  let noresults = [].slice.call(source.querySelectorAll(".br-no-results")).filter(isVisible)

  if (source.querySelector("[data-ri-table-group]") || noresults.length > 0) {

    if (source.querySelector('.br-active-interstitial')) {
      rows = [].slice.call(source.querySelectorAll("[data-paid='false'],.br-cd ul"))
    } else {
      if (source.querySelector('.br-cd')) {
        rows = [].slice.call(source.querySelectorAll(".br-cd ul.editorial"))
      } else {
        rows = [].slice.call(source.querySelectorAll("[data-paid='false']")).filter(isVisible)
      }
    }
    str = rows.length.toString()
  }

  if (str.length > 0) {
    setMetaData('EditorialListingCount', str)
  }

  return str
}


export const getQueryParameters = function getQueryParameters(str) {
  return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
    return n = n.split("="), this[n[0]] = n[1], this
  }.bind({}))[0]
}


export const getPageUX = function getPageUx() {
  if (getMetaData('PageType') === 'article' && getMetaData('Slideshow') === 'true') {
    return 'slideshow'
  }

  return 'scroll'
}

export const generateTID = function generateTID(categoryId) {
  let edic = getUrlParameter('ed_ic') || ''
  let pidObj = JSON.parse(getPID() || '[]')
  let pid = getUrlParameter('pid')
  if (!pid && pidObj) {
    pid = pidObj['p']
  }

  let catString = categoryId ? `|${categoryId}` : ''

  return `${edic}${catString}|${pid}|2|${generateUniqueId()}`
}

// pageTypeMetaData will return 'other' if the type is not 'article', 'calculator', or 'rates-results'
export const pageTypeMetaData = function getPageTypeMetaData(){
  let pageMetaData = getMetaData('PageType')
  if(!(pageMetaData == 'article' || pageMetaData == 'calculator' || pageMetaData == 'rates-results')){
    pageMetaData = 'other'
  }

  return pageMetaData
}

function getUrlParameter(name) {
  let url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')

  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  let results = regex.exec(url)

  if (!results) {
    return null
  }

  if (!results[2]) {
    return ''
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

function generateUniqueId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

generatePurchaseID()

export default {
  getMetaData,
  setMetaData,
  removeMetaData,
  setCCR,
  getCCR,
  setEvents,
  generatePurchaseID,
  generateNewPurchaseID,
  getPurchaseID,
  setPageView,
  getPageView,
  cleanHouse,
  getQueryParameters,
  countPaidListings,
  countEditorialListings,
  setClickedRow,
  getClickedRow,
  getPageUX,
  generateTID,
  pageTypeMetaData
}
